import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

import {
  LayoutDashboard,
  Users,
  Menu,
  X,
  ChevronLeft,
  ChevronRight,
  LogOut,
  BadgeInfo,
  Images,
  Settings
} from "lucide-react";

import logo from "../assets/imgs/logo.png";
import collapseLogo from "../assets/imgs/tiffintapfavicon.ico";
import UserDropdown from "./UserDropdown";

const AdminLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  // console.log("User name is :", name);

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      navigate("/login");
      <Loader />;
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (name) => {
    setOpenMenu(openMenu === name ? null : name);
  };

  const navItems = [
    // {
    //   name: "Dashboard",
    //   icon: <LayoutDashboard size={20} />,
    //   path: "/dashboard",
    // },
    { name: "Manage Users", icon: <Users size={20} />, path: "/users" },
    { name: "FAQ", icon: <BadgeInfo size={20} />, path: "/faqs" },
    {
      name: "Manage website query", icon: (
        <svg id="Group_95212" data-name="Group 95212" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 29.87 31.544">
          <g id="Group_95213" data-name="Group 95213">
            <path id="Path_252627" data-name="Path 252627" d="M29.74,22.2a1.232,1.232,0,0,0-1.03-1,1.858,1.858,0,0,1-1.57-2.1,1.909,1.909,0,0,1,.11-.41,1.247,1.247,0,0,0-.37-1.39,8.129,8.129,0,0,0-2.43-1.41,1.25,1.25,0,0,0-1.41.39,1.813,1.813,0,0,1-1.23.69,1.873,1.873,0,0,1-1.37-.38,2.27,2.27,0,0,1-.31-.31,1.226,1.226,0,0,0-1.4-.39,8.315,8.315,0,0,0-2.27,1.27,1.245,1.245,0,0,0-.39,1.43,1.837,1.837,0,0,1-1.01,2.4,1.529,1.529,0,0,1-.53.13,1.242,1.242,0,0,0-1.08,1,7.349,7.349,0,0,0-.16,1.55,9.246,9.246,0,0,0,.1,1.3,1.242,1.242,0,0,0,1.1,1.04,1.847,1.847,0,0,1,1.66,2.01,1.779,1.779,0,0,1-.16.6,1.22,1.22,0,0,0,.35,1.46,8.061,8.061,0,0,0,2.41,1.39,1.158,1.158,0,0,0,.42.07,1.255,1.255,0,0,0,1.01-.52,1.806,1.806,0,0,1,1.5-.79h.01a1.842,1.842,0,0,1,1.48.74,1.231,1.231,0,0,0,1.45.41,8.1,8.1,0,0,0,2.21-1.32,1.219,1.219,0,0,0,.36-1.42,1.861,1.861,0,0,1,.98-2.42,2.121,2.121,0,0,1,.51-.13,1.22,1.22,0,0,0,1.05-1.01,7.408,7.408,0,0,0,.14-1.41,8.036,8.036,0,0,0-.13-1.47m-1.49,2.37a3.411,3.411,0,0,0-2.73,3.85,3.024,3.024,0,0,0,.13.58,6.644,6.644,0,0,1-1.39.85,3.416,3.416,0,0,0-2.57-1.17h-.01a3.42,3.42,0,0,0-2.63,1.25,6.9,6.9,0,0,1-1.54-.88,3.416,3.416,0,0,0-2.61-4.54,5.708,5.708,0,0,1-.03-.83,7.009,7.009,0,0,1,.08-1.02,3.43,3.43,0,0,0,2.34-1.61,3.381,3.381,0,0,0,.33-2.79,5.994,5.994,0,0,1,1.44-.81,3.435,3.435,0,0,0,4.7.33q.18-.15.36-.33a7.121,7.121,0,0,1,1.58.91,3.428,3.428,0,0,0,2.11,4.22c.14.05.28.09.42.13a6.217,6.217,0,0,1,.08.96,6.8,6.8,0,0,1-.06.9" fill="currentColor" />
            <path id="Path_252628" data-name="Path 252628" d="M21.59,20.214a3.465,3.465,0,1,0,3.459,3.46,3.464,3.464,0,0,0-3.459-3.46m0,5.36a1.9,1.9,0,1,1,1.889-1.9,1.9,1.9,0,0,1-1.889,1.9" fill="currentColor" />
            <path id="Path_252629" data-name="Path 252629" d="M7.115,11.435a.9.9,0,0,0,0,1.8h9.65a.9.9,0,1,0,0-1.8Zm4.339,5.109H7.115a.9.9,0,0,0,0,1.8h4.341a.9.9,0,0,0,0-1.8Z" fill="currentColor" />
            <path id="Path_252630" data-name="Path 252630" d="M11.326,28H4.471A2.677,2.677,0,0,1,1.8,25.32V7.09a2.677,2.677,0,0,1,2.67-2.68H6.326v.226a2.383,2.383,0,0,0,2.381,2.38h8.6a2.383,2.383,0,0,0,2.381-2.38V4.41h1.85a2.646,2.646,0,0,1,2.669,2.623V12.22a.9.9,0,0,0,1.8,0V7.09a4.481,4.481,0,0,0-4.47-4.48h-1.85V2.38A2.382,2.382,0,0,0,17.31,0H8.71A2.383,2.383,0,0,0,6.326,2.38v.23H4.471A4.48,4.48,0,0,0,0,7.09V25.32A4.481,4.481,0,0,0,4.471,29.8h6.855a.9.9,0,1,0,0-1.8ZM8.126,2.38a.58.58,0,0,1,.58-.58h8.6a.58.58,0,0,1,.58.58V4.635a.58.58,0,0,1-.58.58h-8.6a.58.58,0,0,1-.58-.58Z" fill="currentColor" />
          </g>
        </svg>
      ), path: "/manage-inquiry"
    },
    {
      name: "Manage Gallery",
      icon: <Images size={20} />,
      children: [
        {
          name: "Meal Gallery",
          path: "manage-gallery/meal-gallery",
        },
        {
          name: "Service Gallery",
          path: "manage-gallery/service-gallery",
        },
      ],
    },

    {
      name: "Setting",
      icon: <Settings size={20} />,
      children: [
        {
          name: "Add Country",
          path: "setting/add-country",
        },
        {
          name: "Add Meal Category",
          path: "setting/add-meal-category",
        },
      ],
    },
  ];

  /* ------------------ Tooltip component ------------------ */
  const Tooltip = ({ children, label }) => (
    <div className="relative group">
      {children}
      <span
        className="
          absolute left-full top-1/2 -translate-y-1/2 ml-3
          whitespace-nowrap rounded-md bg-black text-white text-xs px-2 py-1
          opacity-0 group-hover:opacity-100 pointer-events-none
          transition-all duration-200
        "
      >
        {label}
      </span>
    </div>
  );

  return (
    <div className="flex h-screen bg-gray-50 text-gray-800 overflow-hidden">
      {/* ===== Sidebar ===== */}
      <aside
        className={`
          fixed lg:static z-50 top-0 left-0 h-screen bg-white shadow-sm flex flex-col transition-all duration-300
          ${isCollapsed ? "w-20" : "w-64"}
          ${isSidebarOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-0"
          }
          overflow-y-auto overflow-x-visible scrollbar-thin scrollbar-thumb-[#ff7448] scrollbar-track-[#ff7448]
        `}
        style={{ overflow: "visible" }}
      >
        {/* Logo + collapse button */}
        <div className="flex items-center justify-between px-4 h-16 flex-shrink-0">
          {isCollapsed ? (
            <img
              src={collapseLogo}
              alt="collapsed logo"
              className="w-auto h-8"
            />
          ) : (
            <img src={logo} alt="logo" className="w-auto h-8" />
          )}

          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="hidden lg:flex p-2 rounded-md hover:bg-gray-100 text-gray-600"
          >
            {isCollapsed ? (
              <ChevronRight size={22} />
            ) : (
              <ChevronLeft size={22} />
            )}
          </button>

          <button
            onClick={() => setIsSidebarOpen(false)}
            className="lg:hidden px-1 py-1 rounded-full w-8 h-8 bg-[#FF6943] text-white flex justify-center items-center"
          >
            <X size={22} />
          </button>
        </div>

        {/* Nav Items */}
        <nav className="flex-1 flex flex-col mt-4 space-y-1 pr-1 relative">
          {navItems.map((item) => (
            <div key={item.name} className="relative">
              {/* Normal items (no children) */}
              {!item.children ? (
                <NavLink
                  to={item.path}
                  onClick={() => {
                    setIsSidebarOpen(false), setOpenMenu(false);
                  }}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-md mx-2 transition-colors
                    ${isActive
                      ? "bg-[#FF6943]/10 text-[#FF6943]"
                      : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  {isCollapsed ? (
                    <Tooltip label={item.name}>{item.icon}</Tooltip>
                  ) : (
                    item.icon
                  )}

                  {!isCollapsed && <span>{item.name}</span>}
                </NavLink>
              ) : (
                <>
                  {/* Parent menu */}
                  <button
                    onClick={() => toggleMenu(item.name)}
                    className={`
                      flex items-center justify-between w-full mx-2 px-4 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer
                      ${openMenu === item.name
                        ? "bg-[#FF6943]/10 text-[#FF6943]"
                        : "text-gray-700 hover:bg-gray-100"
                      }
                    `}
                  >
                    <div className="flex items-center gap-3">
                      {isCollapsed ? (
                        <Tooltip label={item.name}>{item.icon}</Tooltip>
                      ) : (
                        item.icon
                      )}

                      {!isCollapsed && <span>{item.name}</span>}
                    </div>

                    {!isCollapsed && (
                      <ChevronRight
                        size={18}
                        className={`transition-transform duration-200 ${openMenu === item.name ? "rotate-90" : ""
                          }`}
                      />
                    )}
                  </button>

                  {/* Expanded mode children (normal dropdown) */}
                  {!isCollapsed && openMenu === item.name && (
                    <div className="ml-10 mt-1 space-y-1">
                      {item.children.map((child) => (
                        <NavLink
                          key={child.name}
                          to={`/${child.path}`}
                          onClick={() => {
                            // console.log("clcicked");
                            setIsSidebarOpen(false);
                          }}
                          className={({ isActive }) =>
                            `block px-3 py-2 text-sm rounded-md transition-colors
                            ${isActive
                              ? "text-[#FF6943] font-semibold"
                              : "text-gray-600 hover:text-gray-900"
                            }`
                          }
                        >
                          {child.name}
                        </NavLink>
                      ))}
                    </div>
                  )}

                  {/* Collapsed mode children (flyout menu) */}
                  {isCollapsed && openMenu === item.name && (
                    <div
                      className="
                        absolute left-full top-0 ml-2 bg-white shadow-lg border border-[#FF6943]/10 text-gray-800
                        rounded-md p-2 w-40 z-50
                      "
                    >
                      {item.children.map((child) => (
                        <NavLink
                          key={child.name}
                          to={`/${child.path}`}
                          onClick={() => {
                            setOpenMenu(null);
                            console.log("clcicked");
                            setIsSidebarOpen(false);
                          }}
                          className="block px-3 py-2 text-sm rounded hover:bg-gray-100"
                        >
                          {child.name}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </nav>

        {/* Logout */}
        <div className="p-3 flex-shrink-0">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md transition"
          >
            {isCollapsed ? (
              <Tooltip label="Logout">
                <LogOut size={20} />
              </Tooltip>
            ) : (
              <LogOut size={20} />
            )}

            {!isCollapsed && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* ===== Main content area ===== */}
      <div className="flex-1 flex flex-col min-w-0 transition-all duration-300 lg:ml-0">
        <header className="flex items-center justify-between sm:justify-between md:justify-between lg:justify-end xl:justify-end px-4 lg:px-6 h-16 bg-white shadow-sm">
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="lg:hidden px-1 py-1 rounded-full w-8 h-8 bg-[#FF6943] text-white flex justify-center items-center"
          >
            <Menu size={22} />
          </button>

          <UserDropdown className="mr-8" />
        </header>

        <main className="flex-1 overflow-auto scrollbar-thin   scrollbar-track-[#ff7448] p-6 min-w-0">
          <Outlet />
        </main>
      </div>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/30 lg:hidden z-40"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminLayout;
